import { Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { PriceTable } from '../../../../../typings'
import { ReviewProps } from './constants'
import { messages } from './messages'

export function PriceTableRecap(props: ReviewProps) {
  const { config } = props

  if (!config.benefit || !config.scope) return null

  const { benefit, scope } = config

  return (
    <FormattedMessage
      {...messages.priceTable}
      values={{
        b: (content) => <Text variant="action1">{content}</Text>,
        table: (benefit as PriceTable).value,
        applyTo: scope.applyTo,
      }}
    />
  )
}
